// Cycles light → dark → system. Icon reflects the current preference.
import { useTheme } from "../../hooks/useTheme";
import type { Theme } from "../../store/explorerStore";

const NEXT: Record<Theme, Theme> = {
  light: "dark",
  dark: "system",
  system: "light",
};

const ICON: Record<Theme, string> = {
  light: "☀",
  dark: "☾",
  system: "◐",
};

const LABEL: Record<Theme, string> = {
  light: "Light theme — click for dark",
  dark: "Dark theme — click for system",
  system: "System theme — click for light",
};

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={() => setTheme(NEXT[theme])}
      aria-label={LABEL[theme]}
      title={LABEL[theme]}
    >
      <span aria-hidden="true">{ICON[theme]}</span>
    </button>
  );
}
